// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./dev/stylist_parent/components/color-palette/style.scss
// module id = 855
// module chunks = 0